module.exports = __webpack_public_path__ + "img/room_inPreparation.1f62cb0a.svg";